import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from 'react-router';

import { Button, ButtonProps } from '@/components/Button';
import { cn } from '@/utils/classname';

interface LinkProps
  extends ReactRouterLinkProps,
    Pick<ButtonProps, 'styleType'> {
  newTab?: boolean;
  buttonClass?: string;
  disabled?: boolean;
}

export function Link(props: LinkProps) {
  const {
    styleType = 'textPrimary',
    newTab,
    buttonClass,
    disabled,
    ...linkProps
  } = props;

  const isNewTab =
    newTab ||
    (typeof linkProps.to === 'string' && linkProps.to.startsWith('http'));

  return (
    <ReactRouterLink
      {...linkProps}
      {...(isNewTab
        ? {
            target: '_blank',
            rel: 'noreferrer',
          }
        : {})}
      onClick={disabled ? e => e.preventDefault() : linkProps.onClick}
      className={cn(
        linkProps.className,
        disabled && 'pointer-events-none opacity-50'
      )}
      aria-disabled={disabled}
    >
      <Button styleType={styleType} className={buttonClass}>
        {props.children}
      </Button>
    </ReactRouterLink>
  );
}
